module.exports = __webpack_public_path__ + "static/media/videocam-32px.02983fdb.svg";